import { render, staticRenderFns } from "./FooterControlla.vue?vue&type=template&id=5a0107e3&scoped=true&lang=pug&"
import script from "./FooterControlla.vue?vue&type=script&lang=js&"
export * from "./FooterControlla.vue?vue&type=script&lang=js&"
import style0 from "./FooterControlla.vue?vue&type=style&index=0&id=5a0107e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0107e3",
  null
  
)

export default component.exports